import i18n from "i18next";
import { initReactI18next } from "react-i18next";

const resources = {
  fi: {
    translation: {
      common: {
        loading: "Ladataan...",
        sending: "Lähetetään...",
        cancel: "Peruuta",
        all: "Kaikki",
        clear: "Tyhjennä",
        unavailable: "Ei saatavilla",
      },
      login: {
        title: "Kirjaudu",
        username: "Käyttäjätunnus",
        email: "Sähköposti",
        password: "Salasana",
        submit: "Kirjaudu",
        submitting: "Kirjaudutaan...",
        failed: "Kirjautuminen epäonnistui. Tarkista tunnuksesi.",
        forgotPassword: "Unohtuiko salasana?",
      },
      passwordReset: { title: "Aseta uusi salasana", requestTitle: "Palauta salasana", requestDescription: "Anna sähköpostiosoitteesi. Jos tili on oikeutettu, lähetämme kertakäyttöisen linkin.", requestSubmit: "Lähetä palautuslinkki", requestAccepted: "Jos tili on oikeutettu, salasanan palautusviesti lähetetään.", backToLogin: "Takaisin kirjautumiseen", newPassword: "Uusi salasana", confirmPassword: "Vahvista uusi salasana", submit: "Tallenna uusi salasana", errors: { missing: "Palautuslinkki puuttuu tai on virheellinen.", confirm: "Salasanan palautus ei onnistunut." } },
      nav: {
        title: "NP Dashboard",
        login: "Kirjaudu",
        logout: "Kirjaudu ulos",
        language: "Kieli",
        links: {
          corporate: "Hintavertailu",
          daily: "Päivän hinnat",
          analysis: "Päivän hinta-analyysi",
          stats: "Tilastohaku",
          trends: "Hintatrendi",
          admin: "Ylläpito",
          help: "Ohje",
        },
      },
      help: {
        compare: {
          breadcrumb: "Ohje",
          title: "Hintavertailun ohje",
          back: "Takaisin vertailuun",
          description:
            "Näe kootut ruutukaappaukset ja lyhyet ohjeet vertailun käytöstä: syöttökentät, tulokset, lisätiedot ja ABC-kirjautuminen.",
          tabs: {
            compareFlow: {
              label: "Vertailunäkymä",
              description:
                "Syöttökenttien täyttö, vertailun ajo, korttien lukeminen ja ABC-kirjautuminen.",
            },
            abcList: {
              label: "Hae ABC-lista",
              description:
                "ABC-listan haku vaatii puhelinnumeron ja kertakäyttöisen 6-numeroisen koodin.",
            },
          },
          stepLabel: "Vaihe {{number}}",
          steps: {
            overview: {
              title: "Aloitusnäkymä",
              body: "Hintavertailu avautuu tähän näkymään kirjautumisen jälkeen.",
              alt: "Hintavertailun aloitusnäkymä",
            },
            inputs: {
              title: "Täytä syötteet",
              body: "Syötä postinumero/-paikka, litrat, luokka, polttoainetyyppi ja tarvittaessa kate €/L (ALV 0%, 3 desimaalia). Paina Vertaa nappia.",
              alt: "Syötteet täytettynä",
            },
            results: {
              title: "Vertailun tulokset",
              body: "Näet kunkin toimittajan kortin, sijainnin, ALV:lliset kokonaishinnat ja merkin edullisimmalle.",
              alt: "Vertailun tuloskortit",
            },
            details: {
              title: "Lisätiedot",
              body: "Avaa lisätiedot nähdäksesi tarkemmat tiedot esim. osoitteen, tuotteen, katteen ja ALV 0% kokonaishinnan.",
              alt: "Kortin lisätiedot",
            },
            abc_phone: {
              title: "ABC-Kirjautumiseen puhelinnumerosi",
              body: "Paina ABC kirjautuminen nappia. ABC:n hinnat vaativat puhelinnumeron ja 6-numeron koodin. Syötä puhelinnumerosi johon ABC lähettää koodin haun edetessä. Paina Tallenna nappia! Huom: Numerosi tallennetaan tietoihisi ja käytetään jatkossa automaattisesti.",
              alt: "ABC-kirjautumisen modal",
            },
            abc_6number: {
              title: "ABC-kirjautuminen",
              body: "Lisää ABC:ltä SMS:llä saamasi 6-numeron koodi heti, kun se tulee ja paina Lähetä nappia. Huom: koodi voi tulla vain kerran päivässä.",
              alt: "ABC-kirjautumisen modal",
            },
            abc_fetchb: {
              title: "Hae ABC-lista",
              body: "Paina Hae ABC-lista nappia.",
              alt: "ABC-kirjautumisen modal",
            },
          },
        },
      },
      compare: {
        title: "Hintavertailu",
        buttons: {
          enterNeste: "Syötä Neste-koodi",
          abcInfo: "ABC kirjautuminen",
          fetchList: "Hae ABC-lista",
        },
        batch: {
          fetching: "Haetaan ABC-lista...",
          successFallback: "ABC-listan haku suoritettu.",
          error: "ABC-listan haku suoritettu..",
        },
        inputs: {
          postal: "Postinumero tai nimi",
          postalPlaceholder: "esim. 95315 tai TÖRMÄ",
          litres: "Litrat",
          litresPlaceholder: "esim. 2540",
          category: "Polttoaineluokka",
          fuelType: "Polttoainetyyppi",
          profit: "Kate €/L (ALV 0%)",
          profitPlaceholder: "esim. 0.000",
        },
        actions: {
          compare: "Vertaa",
          scrapeMissing: "Scrape puuttuvat kohteet",
          scraping: "Scrapataan puuttuvia kohteita...",
        },
        progress: {
          running: "Vertailu on käynnissä.",
          states: { queued: "jonossa", checking_cache: "tarkistetaan", fetching: "haetaan", waiting_for_otp: "odottaa ABC-koodia", importing: "tallennetaan", success: "valmis", no_data: "ei tietoa", failed: "epäonnistui", cancelled: "peruutettu", expired: "vanhentunut" },
        },
        errors: {
          postalRequired: "Anna postinumero tai -nimi sekä litrat.",
          fuelRequired: "Valitse polttoainetyyppi.",
          profitInvalid: "Kate pitää olla nolla tai suurempi.",
          fuelTypes: "Polttoainetyyppien lataus epäonnistui.",
          postalNotFound: "Postinumeroa ei löydy tietokannasta.",
          invalidPostal: "Virheellinen postinumero tai nimi.",
          compareFailed: "Vertailu epäonnistui.",
          scrapeFailed: "Scrapea ei voitu suorittaa.",
        },
        providerStatus: {
          fetchFailed: "{{provider}}-haku ei onnistunut.",
          showingSuccess: "{{providers}}-tulokset näytetään normaalisti.",
          noData: "{{provider}} ei tarjoa valittua tuotetta tällä alueella.",
        },
        summary: {
          description:
            "Näytetään kohteelle {{location}} ({{code}}), {{litres}} L · Polttoaine: {{fuel}}",
          profit: "Kate: {{value}} €/L",
        },
        card: {
          cheapest: "Edullisin",
          totalWithVat: "Yhteensä (sis. ALV)",
          unitPriceLabel: "Yksikköhinta",
          unitPrice: "Yksikköhinta",
          unitPriceValue: "{{value}} €/L (ALV 0%)",
          litres: "Litrat: {{value}}",
          withProfitDeliveryLabel: "Asiakashinta toimitettuna:",
          withProfitDeliveryExValue: "{{value}} €/L (ALV 0%)",
          withProfitDeliveryIncValue: "{{value}} €/L (sis. ALV)",
          showDetails: "Näytä lisätiedot",
          hideDetails: "Piilota tiedot",
          fields: {
            postalCode: "Postinumero",
            postalName: "Postitoimipaikka",
            fuelType: "Polttoainetyyppi",
            fuelCategory: "Polttoaineluokka",
            product: "Tuote",
            productNumber: "Tuotenumero",
            reportDate: "Raporttipäivä",
            discount: "Alennus",
            delivery: "Toimitus",
            fastDelivery: "Nopea toimitus",
            profit: "Kate",
            totalNoTax: "Yhteensä (ALV 0%)",
          },
        },
        passcode: {
          title: "Neste koodi",
          description: "Syötä uusin 6-numeroinen koodi Nesteen sähköpostista.",
          placeholder: "123456",
          cancel: "Peruuta",
          submit: "Lähetä",
          reset: "Pakota uusi Neste-kirjautuminen ja pyydä koodi",
          requestAgain: "Pyydä uusi Neste-koodi",
          sessionMissing: "Neste-istuntoa ei löytynyt.",
          sessionStatus: "Arvio: {{days}} päivää jäljellä, arvioitu vanheneminen {{date}}. Neste voi pyytää uutta kirjautumista aiemmin.",
          success: "Koodi lähetetty, tietojenhaku jatkuu.",
          resetConfirm: "Tämä poistaa tallennetun Neste-istunnon ja pyytää heti uutta koodia. Muut käyttäjät voivat käyttää tallennettuja hintatietoja haun aikana.",
          resetSuccess: "Neste-kirjautuminen käynnistetty. Odota Nesteen lähettämää koodia.",
          resetPartial: "Neste-istunnon tiedostot nollattiin, mutta käynnissä olevan haun sulkeminen ei valmistunut kokonaan. Tarkista scraper-palvelun lokit.",
          invalid: "Koodin tulee olla tasan 6 numeroa.",
          submitError: "Koodin lähetys epäonnistui.",
          resetError: "Neste-istunnon tyhjennys epäonnistui.",
          renewalStarting: "Neste-kirjautumista käynnistetään.",
          renewalWaiting: "Odotetaan Nesteen lähettämää koodia.",
          renewalImporting: "Uutta Neste-raporttia tuodaan tietokantaan.",
          renewalCompleted: "Uusi Neste-raportti on tallennettu.",
          renewalExpired: "Koodia ei saatu ajoissa. Pyydä uusi koodi.",
          sending: "Lähetetään...",
        },
        abc: {
          title: "ABC kirjautuminen",
          description:
            "Syötä ABC-portaalissa käytettävä puhelinnumero ja viimeisin 6-numeroinen koodi.",
          note:
            "Syötä koodi heti tekstiviestin saavuttua, jotta kirjautuminen pysyy voimassa.",
          phoneLabel: "Puhelinnumero",
          phoneSaved: "Puhelinnumero tallennettu.",
          phoneSaveError: "Puhelinnumeron tallennus epäonnistui.",
          loadError: "ABC kirjautumistietojen haku epäonnistui.",
          phonePlaceholder: "+358401234567",
          savePhone: "Tallenna",
          codeLabel: "6-numeroinen koodi",
          submit: "Lähetä",
          otpSaved: "Koodi lähetetty, tietojenhaku jatkuu.",
          expiresIn: "Syötä ABC-koodi {{seconds}} sekunnin kuluessa.",
          expired: "ABC-koodin syöttöaika päättyi. Aloita uusi vertailu tarvittaessa.",
          codeInvalid: "Koodin tulee olla tasan 6 numeroa.",
          otpSaveError: "Koodin tallennus epäonnistui.",
        },
        accessibility: {
          closePasscodeModal: "Sulje Neste-koodin ikkuna",
          closeAbcModal: "Sulje ABC-kirjautumisen ikkuna",
        },
      },
      trends: {
        title: "Hintatrendi",
        loading: "Ladataan trenditietoja…",
        quickChoices: "Pikavalinnat:",
        week: "1 viikko",
        month: "1 kk",
        year: "Vuosi",
        quarter: "Neljännes:",
        start: "Alku",
        end: "Loppu",
        location: "Sijainti",
        provider: "Toimittaja",
        product: "Tuote",
        fuelCategory: "Polttoaineluokka",
        fuelType: "Polttoainetyyppi",
        quarterLocationLimit: "Neljännesjakso: valitse enintään 5 sijaintia.",
        selected: "Valitut",
        noneSelected: "Ei valintoja",
        saveChart: "Tallenna kuva",
        dayValues: "Päivän arvot",
        line: "Viiva",
        noDayValues: "Valitulle päivälle ei ole arvoja.",
        errors: {
          locations: "Sijainteja ei voitu ladata.",
          invalidDate: "Tarkista alku- ja loppupäivä.",
          missingDate: "Valitse sekä alku- että loppupäivä.",
          dateOrder: "Loppupäivän on oltava alkupäivä tai sitä myöhempi.",
          dateRange: "Valitse enintään 92 päivän ajanjakso.",
          history: "Historiatietoja ei voitu ladata.",
          saveChart: "Kuvaajan tallennus epäonnistui.",
        },
        locations: {
          scheduled: "Aikataulutetut",
          all: "Kaikki kohteet",
          selected: "Valitut sijainnit",
          noneSelected: "Ei valittuja sijainteja",
          searchPlaceholder: "Hae sijaintia",
        },
      },
      chart: {
        title: "Päivän hinnat",
        location: "Sijainti",
        provider: "Toimittaja",
        product: "Tuote",
        fuelCategory: "Polttoaineluokka",
        fuelType: "Polttoainetyyppi",
        comparison: "Hintavertailu",
        orientation: "Kaavion suunta",
        vertical: "Pystysuora",
        horizontal: "Vaakasuora",
        yScale: "Y-akselin skaala",
        automatic: "Automaattinen",
        customRange: "Oma alue",
        minPrice: "Min €/L",
        maxPrice: "Max €/L",
        fitToData: "Sovita dataan",
        customRangeHint: "Jätä tyhjäksi, jos haluat pitää pään automaattisena.",
        rowDetails: "Rivikohdat",
        noRows: "Ei näytettäviä rivejä",
        selectionRequired: "Valitse vähintään yksi toimittaja sekä tuote, polttoaineluokka tai polttoainetyyppi.",
        selected: "Valitut",
        noneSelected: "Ei valintoja",
        error: "Hintatietoja ei voitu ladata.",
        errors: { locations: "Sijainteja ei voitu ladata." },
        locations: { scheduled: "Aikataulutetut", all: "Kaikki kohteet", selected: "Valitut sijainnit", noneSelected: "Ei valittuja sijainteja", searchPlaceholder: "Hae sijaintia" },
        table: { location: "Sijainti", provider: "Toimittaja", product: "Tuote", category: "Luokka", fuelType: "Polttoainetyyppi", unitPrice: "€/L (ALV 0%)" },
      },
      analysis: {
        title: "Päivän hinta-analyysi",
        location: "Sijainti",
        provider: "Toimittaja",
        product: "Tuote",
        fuelType: "Polttoainetyyppi",
        fuelCategory: "Polttoaineluokka",
        litres: "Litramäärä laskentaan",
        discount: "Alennus €/L",
        profit: "Kate €/L",
        fastDelivery: "Pikatoimitus €",
        defaultValue: "tyhjä = oletus",
        noRows: "Ei rivejä valituilla ehdoilla.",
        error: "Hintatietoja ei voitu ladata.",
        errors: { locations: "Sijainteja ei voitu ladata." },
        locations: { scheduled: "Aikataulutetut", all: "Kaikki kohteet", choose: "Valitse sijainnit", selected: "Valitut sijainnit", noneSelected: "Ei valittuja sijainteja", searchPlaceholder: "Hae sijaintia" },
        table: { location: "Sijainti", provider: "Toimittaja", product: "Tuote", category: "Luokka", fuelType: "Polttoainetyyppi", litres: "Litrat", basePrice: "€/L (perus)", discount: "Alennus €/L", profit: "Kate €/L", delivery: "Toimitus €", fastDelivery: "Pikatoimitus €", totalExclVat: "Yhteensä ALV 0%", totalInclVat: "Yhteensä sis. ALV" },
      },
      admin: {
        title: "Ylläpito", version: "Versio {{version}}",
        tabs: { users: "Käyttäjähallinta", fuel: "Polttoaineluokat", targets: "Aikataulutetut kohteet", abcBatch: "ABC-erä", rules: "Laskentasäännöt", database: "Tietokanta", activities: "Aktiviteetit", dataQuality: "Tiedon laatu" },
        dataQuality: { title: "Tiedon laatu", description: "Seuraa tuotteita, joita ei voida luokitella turvallisesti.", active: "Aktiiviset", resolved: "Ratkaistut", provider: "Toimittaja", product: "Tuote", type: "Ongelma", firstSeen: "Ensihavainto", lastSeen: "Viimeksi havaittu", count: "Kertoja", issueTypes: { uncategorized: "Luokittelematon", conflicting: "Ristiriitainen", incomplete_identity: "Puutteellinen tunniste" }, status: "Tila", allProviders: "Kaikki toimittajat", none: "Ei ongelmia.", error: "Tietolaatuongelmia ei voitu ladata." },
        users: { title: "Käyttäjähallinta", email: "Sähköposti", password: "Salasana", newPassword: "Uusi salasana", role: "Rooli", phone: "Puhelin (ABC)", active: "Aktiivinen", user: "Käyttäjä", administrator: "Ylläpitäjä", add: "Lisää käyttäjä", sendSetupLink: "Lähetä salasanan asetuslinkki", pendingSetup: "Odottaa salasanan asetusta", resendSetup: "Lähetä asetuslinkki uudelleen", revokeSetup: "Peruuta asetuslinkki", existing: "Nykyiset käyttäjät", created: "Luotu", save: "Tallenna muutokset", resetPassword: "Vaihda salasana", revokeSessions: "Kirjaa ulos kaikilta laitteilta", removeTestAccount: "Poista testikäyttäjä", confirmRemoveTestAccount: "Poistetaanko kehityksen testikäyttäjä {{email}} pysyvästi?", testAccountRemoved: "Testikäyttäjä poistettu.", noUsers: "Käyttäjiä ei löytynyt.", loading: "Tallennetaan...", accountCreated: "Käyttäjä luotu.", accountUpdated: "Käyttäjä päivitetty.", setupSent: "Salasanan asetuslinkki lähetetty.", setupRevoked: "Salasanan asetuslinkki peruutettu.", noChanges: "Ei tallennettavia muutoksia.", passwordReset: "Salasana vaihdettu ja istunnot päätetty.", sessionsRevoked: "Käyttäjän istunnot päätetty.", phonePlaceholder: "+35840...", errors: { load: "Käyttäjien lataus epäonnistui.", create: "Käyttäjän luonti epäonnistui.", update: "Käyttäjän päivitys epäonnistui.", passwordRequired: "Anna uusi salasana.", resetPassword: "Salasanan vaihto epäonnistui.", revokeSessions: "Istuntojen päättäminen epäonnistui.", setup: "Asetuslinkin käsittely epäonnistui.", removeTestAccount: "Testikäyttäjän poisto epäonnistui." } },
        fuel: { title: "Polttoaineluokkien näkyvyys", description: "Poista luokkia käytöstä piilottaaksesi ne tilapäisesti vertailunäkymistä. Muutokset tulevat voimaan heti kaikille käyttäjille.", loading: "Ladataan luokkia...", none: "Luokkia ei ole saatavilla.", reload: "Lataa uudelleen", save: "Tallenna näkyvyys", saving: "Tallennetaan...", success: "Luokat päivitettiin.", errors: { load: "Polttoaineluokkien lataus epäonnistui.", save: "Polttoaineluokkien päivitys epäonnistui." } },
        prices: { title: "Hintatilanne", daily: "Päivän hinnat", none: "Ei näytettävää hintadataa.", errors: { load: "Hintadataa ei voitu ladata." }, table: { provider: "Toimittaja", location: "Sijainti", product: "Tuote", category: "Luokka", unitPrice: "€/L (ALV 0%)", date: "Päivä" } },
        targets: { cleanupTitle: "Päivittäinen datan tyhjennys", cleanupDescription: "Määritä kellonaika (0–23), jolloin Nesteen ja ST1:n päivittäistaulut tyhjennetään ennen seuraavan päivän ajoja. Kellonaika käyttää palvelimen aikavyöhykettä.", cleanupHour: "Tyhjennysajankohta", cleanupSaved: "Päivittäinen tyhjennysajankohta tallennettu.", title: "Aikataulutetut kohteet", description: "ABC-haku vaatii manuaalisen kirjautumisen. Käytä ABC-erähakua sen kohdelistalle.", postal: "Postinumero / nimi", postalPlaceholder: "esim. 95315", site: "Sivusto", litres: "Litrat", fuelType: "Polttoainetyyppi", time: "Ajankohta", default: "(oletus)", add: "Lisää kohde", added: "Kohde lisätty.", current: "Nykyiset kohteet", refreshList: "Päivitä lista", noTargets: "Ei kohteita.", status: "Tila", actions: "Toiminnot", unsupported: "Ei tuettu aikataulutetussa haussa", skipped: "Ohitetaan", active: "Aktiivinen", disabled: "Pois käytöstä", disable: "Poista käytöstä", activate: "Aktivoi", delete: "Poista", history: "Ajohistoria", started: "Aloitettu", hour: "Tunti", succeeded: "Onnistuneet", reason: "Syy / huomio", videos: "Videot", noLogs: "Ei kirjauksia.", success: "Onnistui", failed: "Virhe", errors: { load: "Kohteiden lataus epäonnistui.", settings: "Ajoituksen asetusten haku epäonnistui.", required: "Postinumero ja sivusto ovat pakollisia.", add: "Kohteen lisääminen epäonnistui.", toggle: "Kohteen tilan muuttaminen epäonnistui.", delete: "Kohteen poistaminen epäonnistui.", hour: "Ajoajan päivittäminen epäonnistui.", cleanup: "Tyhjennysajan tallennus epäonnistui." }, confirmDelete: "Poistetaanko kohde pysyvästi?", siteLabels: { neste: "Neste (yritys)", st1: "ST1 (yritys)" } },
        abcBatch: { title: "ABC-erähaku", description: "Hallinnoi postinumeroita, jotka sisältyvät ABC:n eräajoon. Lista haetaan manuaalisesti Hae ABC-lista -painikkeella vertailusivulta.", status: "Tila", started: "Alkanut", finished: "Päättynyt", results: "Tulokset", error: "Virhe", fetching: "Haetaan ABC-listaa…", refreshStatus: "Päivitä tila", follow: "Seuraa automaattisesti", run: "Käynnistä erähaku", postal: "Postinumero", postalPlaceholder: "esim. 96100", litres: "Litrat", fuel: "Polttoaine", descriptionLabel: "Kuvaus", order: "Järjestys", active: "Aktiivinen", optionalInfo: "Lisätieto (valinnainen)", orderHint: "Pienempi = aiemmin", add: "Lisää kohde", off: "Pois", delete: "Poista", noTargets: "Ei kohteita.", errors: { load: "Tietojen haku epäonnistui.", add: "Lisäys epäonnistui.", update: "Päivitys epäonnistui.", delete: "Poisto epäonnistui.", run: "Erähaku epäonnistui.", order: "Järjestyksen päivitys epäonnistui." }, confirmDelete: "Poistetaanko {{postalCode}}?" },
        rules: { title: "Laskentasäännöt", description: "Säännöt vaikuttavat uusiin hintavertailuihin. Lähteistä haettuja raakahintoja ja hintahistoriaa ei muuteta.", vat: "ALV (%)", deliveryPrices: "Toimitushinta", discounts: "Alennukset", rangeHint: "Rivien tulee alkaa 0 litrasta, jatkua ilman aukkoja ja viimeinen yläraja jätetään tyhjäksi.", addRow: "Lisää rivi", from: "Alkaen (L)", to: "Asti (L)", noUpperLimit: "Ei ylärajaa", value: "Arvo ({{unit}})", delete: "Poista", lastModified: "Viimeksi muutettu: {{value}}", neverModified: "ei vielä muutettu", restore: "Palauta tallennetut", save: "Tallenna säännöt", saving: "Tallennetaan…", saved: "Laskentasäännöt tallennettiin. Muutos vaikuttaa uusiin vertailuihin.", errors: { load: "Laskentasääntöjä ei voitu ladata.", save: "Laskentasääntöjä ei voitu tallentaa." } },
        database: { title: "Tietokanta", description: "Seuraa tietokanta- ja taulukokoja.", refresh: "Päivitä", refreshing: "Päivitetään...", refreshDatabase: "Päivitä tietokanta", totalUsage: "Kokonaiskäyttö", databases: "Tietokannat", collected: "Kerätty", databaseSummary: "Koko {{size}} · {{count}} taulua", table: "Taulu", rows: "Rivit", data: "Data", index: "Indeksi", total: "Yhteensä", errors: { stats: "Tietokantatilastojen lataus epäonnistui." } },
        activities: { title: "Aktiviteetit", description: "Seuraa viimeisimpiä kirjautumisia ja hakuja.", refresh: "Päivitä", refreshing: "Päivitetään...", recentLogins: "Viimeisimmät kirjautumiset", recentScrapes: "Viimeisimmät haut", latestEvents: "Näytetään viimeisimmät {{count}} tapahtumaa", noLogins: "Kirjautumisia ei ole tallennettu.", noScrapes: "Hakuja ei ole tallennettu.", timestamp: "Aikaleima", user: "Käyttäjä", role: "Rooli", ip: "IP-osoite", userAgent: "Selain", event: "Tapahtuma", sites: "Sivustot", postalCodes: "Postinumerot", litres: "Litrat", fuelType: "Polttoainetyyppi", errors: { logins: "Kirjautumisten lataus epäonnistui.", scrapes: "Hakujen lataus epäonnistui." } },
      },
    },
  },
  en: {
    translation: {
      common: {
        loading: "Loading...",
        sending: "Sending...",
        cancel: "Cancel",
        all: "All",
        clear: "Clear",
        unavailable: "Not available",
      },
      login: {
        title: "Log in",
        username: "Username",
        email: "Email",
        password: "Password",
        submit: "Log in",
        submitting: "Logging in...",
        failed: "Login failed. Check your credentials.",
        forgotPassword: "Forgot password?",
      },
      passwordReset: { title: "Set a new password", requestTitle: "Reset password", requestDescription: "Enter your email address. If the account is eligible, we will send a one-time link.", requestSubmit: "Send reset link", requestAccepted: "If the account is eligible, a password-reset message will be sent.", backToLogin: "Back to login", newPassword: "New password", confirmPassword: "Confirm new password", submit: "Save new password", errors: { missing: "The reset link is missing or invalid.", confirm: "Password reset could not be completed." } },
      nav: {
        title: "NP Dashboard",
        login: "Log in",
        logout: "Log out",
        language: "Language",
        links: {
          corporate: "Price Comparison",
          daily: "Daily Prices",
          analysis: "Daily Analysis",
          stats: "Statistics",
          trends: "Trend",
          admin: "Admin",
          help: "Help",
        },
      },
      help: {
        compare: {
          breadcrumb: "Help",
          title: "Compare page help",
          back: "Back to Compare",
          description:
            "Walkthrough with screenshots: filling inputs, running compare, reading results, opening details, and ABC login flow.",
          tabs: {
            compareFlow: {
              label: "Compare flow",
              description:
                "Fill inputs, run compare, read the result cards, and complete ABC login.",
            },
            abcList: {
              label: "Fetch ABC list",
              description:
                "ABC batch fetch requires your phone number and a one-time 6-digit SMS code.",
            },
          },
          stepLabel: "Step {{number}}",
          steps: {
            overview: {
              title: "Landing view",
              body: "The Compare page loads after login with filters and actions ready.",
              alt: "Compare page overview",
            },
            inputs: {
              title: "Fill inputs",
              body: "Enter postal code/name, litres, category, fuel type, and optional profit €/L (ex VAT, 3 decimals). Press Compare to run.",
              alt: "Inputs filled",
            },
            results: {
              title: "Review results",
              body: "See each supplier card with location, total incl VAT (smaller), and the two profit + delivery lines (larger, black, 3 decimals).",
              alt: "Results cards",
            },
            details: {
              title: "Open details",
              body: "Use Show details to view postal info, product, delivery, profit, and totals (ex VAT).",
              alt: "Card details expanded",
            },
            abc_phone: {
              title: "ABC login phone",
              body: "Click ABC login info button. ABC prices require your phone number and a 6-digit SMS code. Enter the phone that will receive the code as the fetch starts.",
              alt: "ABC login modal",
            },
            abc_6number: {
              title: "ABC login code",
              body: "Enter the 6-digit SMS code from ABC as soon as it arrives. You may only receive one code per day for this flow.",
              alt: "ABC login modal",
            },
            abc_fetchb: {
              title: "Fetch ABC list",
              body: "Press the Fetch ABC list button to start the batch and trigger the SMS code flow.",
              alt: "ABC login modal",
            },
          },
        },
      },
      compare: {
        title: "Price Comparison",
        buttons: {
          enterNeste: "Enter Neste passcode",
          abcInfo: "ABC login info",
          fetchList: "Fetch ABC list",
        },
        batch: {
          fetching: "Fetching ABC list...",
          successFallback: "ABC batch completed.",
          error: "ABC batch completed..",
        },
        inputs: {
          postal: "Postal code or name",
          postalPlaceholder: "e.g. 95315 or TÖRMÄ",
          litres: "Litres",
          litresPlaceholder: "e.g. 2540",
          category: "Fuel category",
          fuelType: "Fuel type",
          profit: "Profit €/L (ex VAT)",
          profitPlaceholder: "e.g. 0.000",
        },
        actions: {
          compare: "Compare",
          scrapeMissing: "Scrape missing sites",
          scraping: "Scraping missing sites...",
        },
        progress: {
          running: "Comparison is running.",
          states: { queued: "queued", checking_cache: "checking", fetching: "fetching", waiting_for_otp: "waiting for ABC code", importing: "saving", success: "complete", no_data: "no data", failed: "failed", cancelled: "cancelled", expired: "expired" },
        },
        errors: {
          postalRequired: "Please enter postal code/name and litres.",
          fuelRequired: "Please choose a fuel type.",
          profitInvalid: "Profit must be a non-negative number.",
          fuelTypes: "Failed to load fuel type options.",
          postalNotFound: "Postal code not found in database.",
          invalidPostal: "Invalid postal input.",
          compareFailed: "Compare failed.",
          scrapeFailed: "Scrape failed.",
        },
        providerStatus: {
          fetchFailed: "{{provider}} fetch failed.",
          showingSuccess: "{{providers}} results are shown normally.",
          noData: "{{provider}} does not offer the selected product in this area.",
        },
        summary: {
          description:
            "Showing results for {{location}} ({{code}}), {{litres}} L · Fuel: {{fuel}}",
          profit: "Profit: {{value}} €/L",
        },
        card: {
          cheapest: "Cheapest",
          totalWithVat: "Total (incl. VAT)",
          unitPriceLabel: "Unit price",
          unitPrice: "Unit price",
          unitPriceValue: "{{value}} €/L (ex VAT)",
          litres: "Litres: {{value}}",
          withProfitDeliveryLabel: "Customer price as delivered",
          withProfitDeliveryExValue: "{{value}} €/L (ex VAT)",
          withProfitDeliveryIncValue: "{{value}} €/L (incl VAT)",
          showDetails: "Show details",
          hideDetails: "Hide details",
          fields: {
            postalCode: "Postal code",
            postalName: "Postal name",
            fuelType: "Fuel type",
            fuelCategory: "Fuel category",
            product: "Product",
            productNumber: "Product number",
            reportDate: "Report date",
            discount: "Discount",
            delivery: "Delivery",
            fastDelivery: "Fast delivery",
            profit: "Profit",
            totalNoTax: "Total (ex VAT)",
          },
        },
        passcode: {
          title: "Neste passcode",
          description: "Paste the latest 6-digit code from Neste's email.",
          placeholder: "123456",
          cancel: "Cancel",
          submit: "Submit",
          reset: "Force new Neste login and request code",
          requestAgain: "Request a new Neste code",
          sessionMissing: "Neste session not found.",
          sessionStatus: "Estimate: {{days}} days remaining, estimated expiry {{date}}. Neste may require a new sign-in earlier.",
          success: "Code sent, data fetch continues.",
          resetConfirm: "This removes the saved Neste session and requests a new code immediately. Other users can use saved prices while the renewal runs.",
          resetSuccess: "Neste renewal started. Wait for Neste to send the code.",
          resetPartial: "Neste session files were reset, but active scraper cleanup did not fully complete. Check scraper service logs.",
          invalid: "Passcode must be exactly 6 digits.",
          submitError: "Failed to submit passcode.",
          resetError: "Failed to clear Neste session.",
          renewalStarting: "Starting Neste login.",
          renewalWaiting: "Waiting for Neste to send the code.",
          renewalImporting: "Importing the new Neste report.",
          renewalCompleted: "The new Neste report has been saved.",
          renewalExpired: "The code did not arrive in time. Request a new code.",
          sending: "Sending...",
        },
        abc: {
          title: "ABC login",
          description:
            "Enter the phone number used for the ABC portal and the latest 6-digit code.",
          note: "Enter the code immediately after the SMS arrives to keep the session alive.",
          phoneLabel: "Phone number",
          phoneSaved: "Phone number saved.",
          phoneSaveError: "Failed to save phone number.",
          loadError: "Failed to load ABC credentials.",
          phonePlaceholder: "+358401234567",
          savePhone: "Save",
          codeLabel: "6-digit code",
          submit: "Send",
          otpSaved: "Code stored, data fetch continues.",
          expiresIn: "Enter the ABC code within {{seconds}} seconds.",
          expired: "The ABC code entry window has expired. Start a new comparison if needed.",
          codeInvalid: "Code must be exactly 6 digits.",
          otpSaveError: "Failed to store the code.",
        },
        accessibility: {
          closePasscodeModal: "Close Neste passcode dialog",
          closeAbcModal: "Close ABC login dialog",
        },
      },
      trends: {
        title: "Price trend",
        loading: "Loading trend data…",
        quickChoices: "Quick choices:",
        week: "1 week",
        month: "1 month",
        year: "Year",
        quarter: "Quarter:",
        start: "Start",
        end: "End",
        location: "Location",
        provider: "Provider",
        product: "Product",
        fuelCategory: "Fuel category",
        fuelType: "Fuel type",
        quarterLocationLimit: "Quarter range: select at most 5 locations.",
        selected: "Selected",
        noneSelected: "No selections",
        saveChart: "Save chart",
        dayValues: "Day values",
        line: "Line",
        noDayValues: "No values for the selected date.",
        errors: {
          locations: "Unable to load locations.",
          invalidDate: "Check the start and end dates.",
          missingDate: "Select both a start and end date.",
          dateOrder: "The end date must be on or after the start date.",
          dateRange: "Select a range of at most 92 days.",
          history: "Unable to load history data.",
          saveChart: "Unable to save the chart.",
        },
        locations: {
          scheduled: "Scheduled",
          all: "All locations",
          selected: "Selected locations",
          noneSelected: "No selected locations",
          searchPlaceholder: "Search location",
        },
      },
      chart: {
        title: "Daily prices",
        location: "Location",
        provider: "Provider",
        product: "Product",
        fuelCategory: "Fuel category",
        fuelType: "Fuel type",
        comparison: "Price comparison",
        orientation: "Chart orientation",
        vertical: "Vertical",
        horizontal: "Horizontal",
        yScale: "Y-axis scale",
        automatic: "Automatic",
        customRange: "Custom range",
        minPrice: "Min €/L",
        maxPrice: "Max €/L",
        fitToData: "Fit to data",
        customRangeHint: "Leave blank to keep an end automatic.",
        rowDetails: "Row details",
        noRows: "No rows to display",
        selectionRequired: "Select at least one provider and a product, fuel category, or fuel type.",
        selected: "Selected",
        noneSelected: "No selections",
        error: "Unable to load price data.",
        errors: { locations: "Unable to load locations." },
        locations: { scheduled: "Scheduled", all: "All locations", selected: "Selected locations", noneSelected: "No selected locations", searchPlaceholder: "Search location" },
        table: { location: "Location", provider: "Provider", product: "Product", category: "Category", fuelType: "Fuel type", unitPrice: "€/L (ex VAT)" },
      },
      analysis: {
        title: "Daily price analysis",
        location: "Location",
        provider: "Provider",
        product: "Product",
        fuelType: "Fuel type",
        fuelCategory: "Fuel category",
        litres: "Litres for calculation",
        discount: "Discount €/L",
        profit: "Profit €/L",
        fastDelivery: "Fast delivery €",
        defaultValue: "blank = default",
        noRows: "No rows match the selected conditions.",
        error: "Unable to load price data.",
        errors: { locations: "Unable to load locations." },
        locations: { scheduled: "Scheduled", all: "All locations", choose: "Choose locations", selected: "Selected locations", noneSelected: "No selected locations", searchPlaceholder: "Search location" },
        table: { location: "Location", provider: "Provider", product: "Product", category: "Category", fuelType: "Fuel type", litres: "Litres", basePrice: "€/L (base)", discount: "Discount €/L", profit: "Profit €/L", delivery: "Delivery €", fastDelivery: "Fast delivery €", totalExclVat: "Total ex VAT", totalInclVat: "Total incl. VAT" },
      },
      admin: {
        title: "Admin", version: "Version {{version}}",
        tabs: { users: "User management", fuel: "Fuel categories", targets: "Scheduled targets", abcBatch: "ABC batch", rules: "Calculation rules", database: "Database", activities: "Activities", dataQuality: "Data quality" },
        dataQuality: { title: "Data quality", description: "Track products that cannot be categorized safely.", active: "Active", resolved: "Resolved", provider: "Provider", product: "Product", type: "Issue", firstSeen: "First seen", lastSeen: "Last seen", count: "Count", issueTypes: { uncategorized: "Uncategorized", conflicting: "Conflicting", incomplete_identity: "Incomplete identity" }, status: "Status", allProviders: "All providers", none: "No issues.", error: "Unable to load data-quality issues." },
        users: { title: "User management", email: "Email", password: "Password", newPassword: "New password", role: "Role", phone: "Phone (ABC)", active: "Active", user: "User", administrator: "Administrator", add: "Add user", sendSetupLink: "Send password-setup link", pendingSetup: "Waiting for password setup", resendSetup: "Resend setup link", revokeSetup: "Revoke setup link", existing: "Existing users", created: "Created", save: "Save changes", resetPassword: "Reset password", revokeSessions: "Sign out on all devices", removeTestAccount: "Remove test account", confirmRemoveTestAccount: "Permanently remove development test account {{email}}?", testAccountRemoved: "Test account removed.", noUsers: "No users found.", loading: "Saving...", accountCreated: "User created.", accountUpdated: "User updated.", setupSent: "Password-setup link sent.", setupRevoked: "Password-setup link revoked.", noChanges: "No changes to save.", passwordReset: "Password reset and sessions ended.", sessionsRevoked: "User sessions ended.", phonePlaceholder: "+35840...", errors: { load: "Failed to load users.", create: "Failed to create user.", update: "Failed to update user.", passwordRequired: "Enter a new password.", resetPassword: "Password reset failed.", revokeSessions: "Ending sessions failed.", setup: "Password-setup link action failed.", removeTestAccount: "Removing the test account failed." } },
        fuel: { title: "Fuel category visibility", description: "Disable categories to hide them from compare views temporarily. Changes take effect immediately for all users.", loading: "Loading categories...", none: "No categories available.", reload: "Reload", save: "Save visibility", saving: "Saving...", success: "Categories updated.", errors: { load: "Failed to load fuel categories.", save: "Failed to update fuel categories." } },
        prices: { title: "Price snapshots", daily: "Daily prices", none: "No price data to display.", errors: { load: "Failed to load price data." }, table: { provider: "Provider", location: "Location", product: "Product", category: "Category", unitPrice: "€/L (ex VAT)", date: "Date" } },
        targets: { cleanupTitle: "Daily data cleanup", cleanupDescription: "Set the hour (0–23) when Neste and ST1 daily tables are cleared before the next day's runs. The hour uses the server time zone.", cleanupHour: "Cleanup time", cleanupSaved: "Daily cleanup time saved.", title: "Scheduled targets", description: "ABC fetching requires manual login. Use ABC batch fetch for its target list.", postal: "Postal code / name", postalPlaceholder: "e.g. 95315", site: "Site", litres: "Litres", fuelType: "Fuel type", time: "Time", default: "(default)", add: "Add target", added: "Target added.", current: "Current targets", refreshList: "Refresh list", noTargets: "No targets.", status: "Status", actions: "Actions", unsupported: "Not supported in scheduled fetch", skipped: "Skipped", active: "Active", disabled: "Disabled", disable: "Disable", activate: "Activate", delete: "Delete", history: "Run history", started: "Started", hour: "Hour", succeeded: "Succeeded", reason: "Reason / note", videos: "Videos", noLogs: "No records.", success: "Succeeded", failed: "Failed", errors: { load: "Failed to load targets.", settings: "Failed to load scheduler settings.", required: "Postal code and site are required.", add: "Failed to add target.", toggle: "Failed to update target status.", delete: "Failed to delete target.", hour: "Failed to update run hour.", cleanup: "Failed to save cleanup time." }, confirmDelete: "Delete this target permanently?", siteLabels: { neste: "Neste (corporate)", st1: "ST1 (corporate)" } },
        abcBatch: { title: "ABC batch fetch", description: "Manage postal codes included in the ABC batch run. Fetch the list manually with the Fetch ABC list button on the comparison page.", status: "Status", started: "Started", finished: "Finished", results: "Results", error: "Error", fetching: "Fetching ABC list…", refreshStatus: "Refresh status", follow: "Follow automatically", run: "Start batch fetch", postal: "Postal code", postalPlaceholder: "e.g. 96100", litres: "Litres", fuel: "Fuel", descriptionLabel: "Description", order: "Order", active: "Active", optionalInfo: "Extra information (optional)", orderHint: "Smaller = earlier", add: "Add target", off: "Off", delete: "Delete", noTargets: "No targets.", errors: { load: "Failed to load data.", add: "Failed to add target.", update: "Failed to update target.", delete: "Failed to delete target.", run: "Batch fetch failed.", order: "Failed to update order." }, confirmDelete: "Delete {{postalCode}}?" },
        rules: { title: "Calculation rules", description: "Rules affect new price comparisons. Raw prices and price history fetched from sources are not changed.", vat: "VAT (%)", deliveryPrices: "Delivery price", discounts: "Discounts", rangeHint: "Rows must begin at 0 litres, continue without gaps and leave the final upper limit empty.", addRow: "Add row", from: "From (L)", to: "To (L)", noUpperLimit: "No upper limit", value: "Value ({{unit}})", delete: "Delete", lastModified: "Last modified: {{value}}", neverModified: "not modified yet", restore: "Restore saved", save: "Save rules", saving: "Saving…", saved: "Calculation rules saved. The change affects new comparisons.", errors: { load: "Unable to load calculation rules.", save: "Unable to save calculation rules." } },
        database: { title: "Database", description: "Track database and table sizes.", refresh: "Refresh", refreshing: "Refreshing...", refreshDatabase: "Refresh database", totalUsage: "Total usage", databases: "Databases", collected: "Collected", databaseSummary: "Size {{size}} · {{count}} tables", table: "Table", rows: "Rows", data: "Data", index: "Index", total: "Total", errors: { stats: "Failed to load database stats." } },
        activities: { title: "Activities", description: "Track recent sign-ins and searches.", refresh: "Refresh", refreshing: "Refreshing...", recentLogins: "Recent login activity", recentScrapes: "Recent scrape activity", latestEvents: "Showing the latest {{count}} events", noLogins: "No login activity recorded.", noScrapes: "No scrape activity recorded.", timestamp: "Timestamp", user: "User", role: "Role", ip: "IP address", userAgent: "User agent", event: "Event", sites: "Sites", postalCodes: "Postal codes", litres: "Litres", fuelType: "Fuel type", errors: { logins: "Failed to load login events.", scrapes: "Failed to load scrape events." } },
      },
    },
  },
};

i18n.use(initReactI18next).init({
  resources,
  lng: "fi",
  fallbackLng: "fi",
  interpolation: {
    escapeValue: false,
  },
});

export default i18n;
